import { StatusGroupIds, TypeGroupIds } from './../../../../modules/shared/constants/category-groupid.constants';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { LeadService } from 'src/app/leads/leadService';
import { AppMainComponent } from '../../../../app.main.component';
import { ObjectNames } from '../../../../shared/constants';
import { CrmLeadsFieldService } from './fields.service';
import { Answer } from '../../constants/constants';
import { FeatureSubscriptionInfoEnums } from 'src/app/modules/shared/enums/feature-subscription-info.enum';
import { SubscriptionFeatureLimitM } from 'src/app/modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { OrganizationSubscriptionService } from 'src/app/modules/shared/services/organization-subscription.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-leads-fields',
    templateUrl: './fields.component.html',
    styleUrls: ['./fields.component.scss'],
    providers: [ConfirmationService, CrmLeadsFieldService]
})
export class CrmLeadsFieldsComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() addNewField: any;
    @Input() allLeadChannels;
    @Output() reLoadConfigurations = new EventEmitter();

    leadsSources = [];
    leadsStatus = [];
    leadsTypes = [];
    leadsEmail = [];
    emailConfigLead;
    leadsPhone = [];
    phoneConfigLead;
    leadsSocial = [];
    socialConfigLead;
    leadTypeId = 0;
    ratings = [];
    employeesMounts = [];
    revenue = [];
    ownerships = [];
    industries = [];
    qualifiedReasons = [];
    unQualifiedReasons = [];
    currencies = [];
    qualifiedId;
    unQualifiedId;
    emailConfigAccount;
    phoneConfigAccount;
    socialConfigAccount;
    configTemp;
    answertypeConstants = Answer;
    activeId: number;
    inactiveId: number;
    activeReason: Array<any>;
    inactiveReason: Array<any>;
    copiedList = [];
    copiedTypes = [];
    copiedSources = [];
    copiedStatus = [];

    leadDataTypes = [
        { id: 0, name: "Lead Types", code: "lead types" },
        { id: 1, name: "Lead Source", code: "lead source" },
        { id: 2, name: "Rating", code: "rating" },
        { id: 3, name: "No. of Employees", code: "employee amount" },
        { id: 4, name: "Annual Revenue", code: "income" },
        { id: 5, name: "Ownership Type", code: "ownership type" },
        { id: 6, name: "Industry", code: "industry" },
        { id: 7, name: "Lead Email", code: "lead email" },
        { id: 8, name: "Lead Phone", code: "lead phone" },
        { id: 9, name: "Lead Social Profile", code: "lead social" },
        { id: 10, name: "Lead Status", code: "lead status" },
        { id: 11, name: "Qualified Reason", code: "Qualified" },
        { id: 12, name: "UnQualified Reason", code: "Un-Qualified" },
        { id: 13, name: "Active Reason", code: "LeadActivatedReason" },
        { id: 14, name: "Inactive Reason", code: "LeadInactivatedReason" },
        { id: 15, name: "Tags", code: "tags" },

        // { id: 15, name: "Currency", code: "currency" },
    ];
    addEditLeadHeader = "";
    displayAddLeadData = false;
    showValidation: boolean = false;

    selectedLeadDataType;
    leadDataTemp: Record<string, any>;
    formSubmitted = false;
    invalidData = false;
    showActiveBtn: boolean = false;

    emailToLead = [
        { id: 1, name: "Email To Lead", isDefault: true }
    ]

    moduleName: string = 'lead';

    //tags
    tags = [
        {id:1,value:"Success",color:"#3B82F6",isActive:true},
        {id:2,value:"Info",color:"#22C55E",isActive:true},
        {id:3,value:"Warning",color:"#F59E0B",isActive:true},
        {id:4,value:"Danger",color:"#EF4444",isActive:true},
    ]
    tagList:any[] = [];
    displayEditTag:boolean = false;
    tempTag:any = {id:0,name:"", color:"#000000",statusId:0,isActive:false};

    subscriptionLimit: SubscriptionFeatureLimitM = null;

    constructor(
        private app: AppMainComponent,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private service: ConfigurationService,
        private appMainService: AppMainService,
        private fieldService: CrmLeadsFieldService,
        private leadService: LeadService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.addNewField && changes.addNewField.currentValue) {
            const newRecordObj = changes.addNewField.currentValue;
            if (newRecordObj.name == 'Field') {
                this.showNewField();
            }
        }
    }

    ngOnInit(): void {
        this.checkSubscriptionLimit();
        this.fetchLeadsSources();
        this.loadRatings();
        this.loadCurrencies();
        this.loadEmployeeCountList();
        this.loadRevenuList();
        this.loadOwnerShipList();
        this.loadIndustries();
        this.loadLeadConfigurations();
        this.getQualifyReasons('Qualified');
        this.getQualifyReasons('Un-Qualified');
        this.getActiveInactiveReason('LeadActivatedReason');
        this.getActiveInactiveReason('LeadInactivatedReason');
        this.loadTages();
    }

    checkSubscriptionLimit() {
        this.organizationSubscriptionService
            .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Tags)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.subscriptionLimit = response;
                }
            })
    }

    get subscriptionLimitReached(){
        return ((this.selectedLeadDataType?.id == 15)
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    loadCurrencies(fromAdd?) {
        this.appMainService.isShowSpinner('loadCurrencies');
        this.fieldService.getCurrencies().subscribe(currencies => {
            this.currencies = currencies || [];

            if (fromAdd) {
                this.copiedList = this.currencies;
            }

            this.appMainService.isHideSpinner('loadCurrencies');
        }, () => {
            this.appMainService.isHideSpinner('loadCurrencies');
        });
    }

    getQualifyReasons(groupName, fromAdd?) {
        this.appMainService.isShowSpinner('getQualifyReasons')
        this.leadService.getQualifyDataByName(groupName).subscribe(
            dataName => {
                this.appMainService.isHideSpinner('getQualifyReasons');
                dataName &&
                    this.leadService.getQualifyReasons(dataName.id).subscribe(
                        res => {
                            if (groupName == 'Qualified') {
                                this.qualifiedId = dataName.id;
                                this.qualifiedReasons = res ? res : [];
                                this.qualifiedReasons.sort((a, b) => a.name.localeCompare(b.name));
                                if (fromAdd) {
                                    this.copiedList = this.qualifiedReasons;
                                }
                            } else {
                                this.unQualifiedId = dataName.id;
                                this.unQualifiedReasons = res ? res : [];
                                this.unQualifiedReasons.sort((a, b) => a.name.localeCompare(b.name));
                                if (fromAdd) {
                                    this.copiedList = this.unQualifiedReasons;
                                }
                            }
                        },
                        () => {
                            this.appMainService.isHideSpinner('getQualifyReasons');
                        });
            },
            () => {
                this.appMainService.isHideSpinner('getQualifyReasons');
            })
    }

    get color(): string {
        return this.leadDataTemp?.color ?? '#000000';
    }

    showNewField() {
        this.selectedLeadDataType = null;
        this.leadDataTemp = {
            name: "",
            description: "",
            color: '#000000',
            id: 0,
            code: '',
            checked: false
        }
        this.displayAddLeadData = true;
        this.formSubmitted = false;
        this.addEditLeadHeader = "Add Field Data";
        this.invalidData = false;
    }

    getLeadDataType() {
        if (this.selectedLeadDataType ? this.selectedLeadDataType.code == 'lead email' : null
            || this.selectedLeadDataType ? this.selectedLeadDataType.code == 'lead phone' : null
                || this.selectedLeadDataType ? this.selectedLeadDataType.code == 'lead social' : null) {
            this.leadDataTemp = {
                "name": "",
                "description": "",
                "id": 0,
                "code": "",
                "checked": false
            }
        } else if (this.selectedLeadDataType ? this.selectedLeadDataType.code == 'lead status' : null) {
            this.leadDataTemp = {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": this.app.userIP,
                createdBy: this.app.user.userId,
                "updatedBy": this.app.user.userId,
                "createdDate": new Date().toISOString(),
                "updatedDate": new Date().toISOString(),
                "organizationId": this.app.user.organizationId,
                "name": "",
                "description": "",
                "groupId": TypeGroupIds.LeadTypeLeadAPI,
                "typeId": null
            }
        } else if (this.selectedLeadDataType ? this.selectedLeadDataType.code == 'lead types' : null) {
            this.leadDataTemp = {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": this.app.userIP,
                createdBy: this.app.user.userId,
                "updatedBy": this.app.user.userId,
                "createdDate": new Date().toISOString(),
                "updatedDate": new Date().toISOString(),
                "name": "",
                "parentTypeId": 0,
                "description": "",
                "groupId": TypeGroupIds.LeadTypeLeadAPI,
                "group": null,
                "statusId": 1,
                "status": null,
                "organizationId": this.app.user.organizationId,
                "colorCodeId": null
            }
        }
        else if (this.selectedLeadDataType ? this.selectedLeadDataType.code == 'Un-Qualified' : null
            || this.selectedLeadDataType ? this.selectedLeadDataType.code == 'Qualified' : null) {
            this.leadDataTemp = {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": this.app.userIP,
                createdBy: this.app.user.userId,
                "updatedBy": this.app.user.userId,
                "createdDate": new Date().toISOString(),
                "updatedDate": new Date().toISOString(),
                "organizationId": this.app.user.organizationId,
                "name": "",
                "description": "",
                "statusId": 1,
                "isActive": true,
                "isDefault": false
            }
        }
        else if (this.selectedLeadDataType.code == "LeadActivatedReason" || this.selectedLeadDataType.code == "LeadInactivatedReason") {
            this.leadDataTemp = {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": this.app.userIP,
                createdBy: this.app.user.userId,
                "updatedBy": this.app.user.userId,
                "createdDate": new Date().toISOString(),
                "updatedDate": new Date().toISOString(),
                "organizationId": this.app.user.organizationId,
                "name": "",
                "description": "",
                "statusId": 1,
                "isActive": true,
                "isDefault": false
            }
        } else {
            this.leadDataTemp = {
                "id": 0,
                "createdSource": this.app.userIP,
                "updatedSource": this.app.userIP,
                createdBy: this.app.user.userId,
                color: '#000000',
                "updatedBy": this.app.user.organizationId,
                "createdDate": new Date().toISOString(),
                "updatedDate": new Date().toISOString(),
                "name": "",
                "description": "",
                "statusId": 1,
                "organizationId": this.app.user.organizationId,
            }
        }
    }

    loadLeadConfigurations() {
        this.service.getConfigurationByModuleName('Lead')
            .subscribe(configs => {
                this.appMainService.isHideSpinner('loadConfig');

                this.emailConfigLead = configs.find(s => s.name == ObjectNames.LEAD_EMAIL_TYPES && s.typeId == 93);
                this.leadsEmail = this.emailConfigLead ? JSON.parse(this.emailConfigLead.configurationDetails[0].configJSONValue) : [];

                this.phoneConfigLead = configs.find(s => s.name == ObjectNames.LEAD_PHONE_TYPES && s.typeId == 94);
                this.leadsPhone = this.phoneConfigLead ? JSON.parse(this.phoneConfigLead.configurationDetails[0].configJSONValue) : [];

                this.socialConfigLead = configs.find(s => s.name == ObjectNames.LEAD_SOCIAL_TYPES && s.typeId == 95);
                this.leadsSocial = this.socialConfigLead ? JSON.parse(this.socialConfigLead.configurationDetails[0].configJSONValue) : [];
            },
                err => {
                    this.appMainService.isHideSpinner('loadConfig');
                }
            );
    }

    fetchLeadsSources() {
        this.appMainService.isShowSpinner('fetchLeadsSources');
        this.leadService.getAllSources(this.app.user.organizationId)
            .then(sources => {
                this.leadsSources = sources || [];
                this.fetchLeadsStatus();
                this.appMainService.isHideSpinner('fetchLeadsSources');
            })
            .catch(() => {
                this.appMainService.isHideSpinner('fetchLeadsSources');
            });
    }

    fetchLeadsStatus() {
        this.appMainService.isShowSpinner('fetchLeadsStatus');
        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId)
            .then(statuses => {
                this.leadsStatus = statuses || [];
                this.fetchLeadsTypes();
                this.appMainService.isHideSpinner('fetchLeadsStatus');
            })
            .catch(() => {
                this.appMainService.isHideSpinner('fetchLeadsStatus');
            });
    }

    fetchLeadsTypes() {
        this.appMainService.isShowSpinner('fetchLeadsTypes');
        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI)
            .then(types => {
                this.leadsTypes = types || [];
                this.leadsTypes.sort((a, b) => a.name.localeCompare(b.name));
                this.copiedTypes = JSON.parse(JSON.stringify(this.leadsTypes));
                this.appMainService.isHideSpinner('fetchLeadsTypes');
            })
            .catch(() => {
                this.appMainService.isHideSpinner('fetchLeadsTypes');
            });
    }

    saveLeadDataAdd() {
        if (this.addEditLeadHeader == "Add Field Data") {
            if (!this.selectedLeadDataType || !this.leadDataTemp.name || this.leadDataTemp.name.trim() === '') {
                this.showValidation = true;
                return;
            }

            this.showValidation = false;

            if (this.selectedLeadDataType.code == 'lead source') {
                let lowerCaseNames = [];
                for (let s of this.leadsSources) {
                    lowerCaseNames.push(s.name.toLowerCase())
                }
                if (lowerCaseNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addLeadSource(this.leadDataTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllSources(this.app.user.organizationId).then(sources => {
                            this.leadsSources = sources;
                            this.copiedList = this.leadsSources;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'industry') {
                let lowerCaseNames = [];
                for (let s of this.industries) {
                    lowerCaseNames.push(s.name.toLowerCase())
                }
                if (lowerCaseNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addIndustry(this.leadDataTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllIndustries().then(industries => {
                            this.industries = industries;
                            this.copiedList = this.industries;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'income') {
                let lowerCaseNames = [];
                for (let s of this.revenue) {
                    lowerCaseNames.push(s.name.toLowerCase())
                }
                if (lowerCaseNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addRevenue(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllRevenues().then(revenue => {
                            this.revenue = revenue;
                            this.copiedList = this.revenue;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'employee amount') {
                let lowerCaseNames = [];
                for (let s of this.employeesMounts) {
                    lowerCaseNames.push(s.name.toLowerCase())
                }
                if (lowerCaseNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addEmployeesNo(this.leadDataTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllEmployeesCount().then(count => {
                            this.employeesMounts = count;
                            this.copiedList = this.employeesMounts;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'lead status') {
                let lowerCaseNames = [];
                for (let s of this.leadsStatus) {
                    lowerCaseNames.push(s.name.toLowerCase())
                }
                if (lowerCaseNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addLeadStatus(this.leadDataTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(statuses => {
                            this.leadsStatus = statuses;
                            this.copiedList = this.leadsStatus;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'lead types') {
                let lowerLeadNames = [];
                for (let s of this.leadsTypes) {
                    lowerLeadNames.push(s.name.toLowerCase())
                }
                if (lowerLeadNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addLeadType(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
                            this.leadsTypes = types;
                            this.copiedTypes = this.leadsTypes;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'lead email') {
                let lowerLeadNames = [];
                for (let s of this.leadsEmail) {
                    lowerLeadNames.push(s.name.toLowerCase())
                }
                if (lowerLeadNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.configTemp = {
                        "id": this.emailConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.emailConfigLead.organizationId,
                        "name": this.emailConfigLead.name,
                        "description": this.emailConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.emailConfigLead.objectId,
                        "levelId": this.emailConfigLead.levelId,
                        "levelRecordId": this.emailConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.emailConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.emailConfigLead.typeId
                    }
                    this.leadDataTemp.id = this.leadsEmail.length + 1;
                    this.leadDataTemp.code = 'other';
                    this.leadsEmail.push(this.leadDataTemp);
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsEmail);

                    this.service.updateConfiguration(this.configTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.emailConfigLead = configs.find(s => s.name == ObjectNames.LEAD_EMAIL_TYPES && s.typeId == 93);
                        //     this.leadsEmail = JSON.parse(this.emailConfigLead.configurationDetails[0].configJSONValue);
                        //     this.invalidData = false;
                        // });
                        this.loadLeadConfigurations();
                        this.invalidData = false;
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'lead phone') {
                let lowerLeadNames = [];
                for (let s of this.leadsPhone) {
                    lowerLeadNames.push(s.name.toLowerCase())
                }
                if (lowerLeadNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.configTemp = {
                        "id": this.phoneConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.phoneConfigLead.organizationId,
                        "name": this.phoneConfigLead.name,
                        "description": this.phoneConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.phoneConfigLead.objectId,
                        "levelId": this.phoneConfigLead.levelId,
                        "levelRecordId": this.phoneConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.phoneConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.phoneConfigLead.typeId
                    }
                    this.leadDataTemp.id = this.leadsPhone.length + 1;
                    this.leadDataTemp.code = 'other';
                    this.leadsPhone.push(this.leadDataTemp);
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsPhone);

                    this.service.updateConfiguration(this.configTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.phoneConfigLead = configs.find(s => s.name == ObjectNames.LEAD_PHONE_TYPES && s.typeId == 94);
                        //     this.leadsPhone = this.phoneConfigLead ? JSON.parse(this.phoneConfigLead.configurationDetails[0].configJSONValue) : [];
                        //     this.invalidData = false;
                        // });
                        this.loadLeadConfigurations();
                        this.invalidData = false;
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'lead social') {
                let lowerLeadNames = [];
                for (let s of this.leadsSocial) {
                    lowerLeadNames.push(s.name.toLowerCase())
                }
                if (lowerLeadNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.configTemp = {
                        "id": this.socialConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.socialConfigLead.organizationId,
                        "name": this.socialConfigLead.name,
                        "description": this.socialConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.socialConfigLead.objectId,
                        "levelId": this.socialConfigLead.levelId,
                        "levelRecordId": this.socialConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.socialConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.socialConfigLead.typeId
                    }
                    this.leadDataTemp.id = this.leadsSocial.length + 1;
                    this.leadDataTemp.code = 'other';
                    this.leadsSocial.push(this.leadDataTemp);
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsSocial);

                    this.service.updateConfiguration(this.configTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.socialConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_SOCIAL_TYPES && s.typeId == 95)[0];
                        //     this.leadsSocial = JSON.parse(this.socialConfigLead.configurationDetails[0].configJSONValue);
                        //     this.invalidData = false;
                        // });
                        this.loadLeadConfigurations();
                        this.invalidData = false;
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'rating') {
                let lowerLeadNames = [];
                for (let s of this.ratings) {
                    lowerLeadNames.push(s.name.toLowerCase())
                }
                if (lowerLeadNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addRating(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.loadRatings(true);
                        this.displayAddLeadData = false;
                        this.invalidData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'ownership type') {
                let lowerAccountNames = [];
                for (let s of this.ownerships) {
                    lowerAccountNames.push(s.name.toLowerCase())
                }
                if (lowerAccountNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.service.addOwnership(this.leadDataTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        this.loadOwnerShipList(true);
                        this.displayAddLeadData = false;
                        this.invalidData = false;
                    });
                }
            } else if (this.selectedLeadDataType.code == 'Qualified' || this.selectedLeadDataType.code == 'Un-Qualified') {
                this.addQualifyReason();
            } else if (this.selectedLeadDataType.code == 'LeadActivatedReason' || this.selectedLeadDataType.code == 'LeadInactivatedReason') {
                this.addActiveInactiveReason();
            } else if (this.selectedLeadDataType.code == 'currency') {
                this.addCurrency();
            }else if(this.selectedLeadDataType.code == 'tags'){
                if(!this.leadDataTemp?.color){
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select the tag color' });
                  return;
                }
                  this.addTags();
              }
        } else if (this.addEditLeadHeader == "Edit Field Data") {
            if (!this.leadDataTemp.name || this.leadDataTemp.name.trim() === '') {
                this.showValidation = true;
                return;
            }

            this.showValidation = false;

            if (this.leadTypeId == 1) {
                const duplicateRecord = this.leadsSources.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditLeadSource(this.leadDataTemp)
                        .then(() => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                            this.leadService.getAllSources(this.app.user.organizationId).then(sources => {
                                this.leadsSources = sources;
                                this.copiedList = this.leadsSources;
                                this.invalidData = false;
                            });
                            this.displayAddLeadData = false;
                        })
                        .catch(err => {
                            const detail = err.status === 422 ? err.error : err.error.Message;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail
                            });
                            this.invalidData = false;
                        });
                }
            } else if (this.leadTypeId == 6) {
                const duplicateRecord = this.industries.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditIndustry(this.leadDataTemp)
                        .then(() => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                            this.leadService.getAllIndustries().then(industries => {
                                this.industries = industries;
                                this.copiedList = this.industries;
                                this.invalidData = false;
                            });
                            this.displayAddLeadData = false;
                        })
                        .catch(err => {
                            this.invalidData = false;
                            const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail
                            });
                        });
                }
            } else if (this.leadTypeId == 4) {
                const duplicateRecord = this.revenue.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditRevenue(this.leadDataTemp)
                        .then(() => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                            this.leadService.getAllRevenues().then(revenue => {
                                this.revenue = revenue;
                                this.copiedList = this.revenue;
                                this.invalidData = false;
                            });
                            this.displayAddLeadData = false;
                        })
                        .catch(err => {
                            this.invalidData = false;
                            const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail
                            });
                        });
                }
            } else if (this.leadTypeId == 3) {
                const duplicateRecord = this.employeesMounts.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.appMainService.isShowSpinner('EditEmployeesNo');
                    this.service.EditEmployeesNo(this.leadDataTemp)
                        .then(() => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                            this.leadService.getAllEmployeesCount().then(count => {
                                this.employeesMounts = count;
                                this.copiedList = this.employeesMounts;
                                this.invalidData = false;
                            });
                            this.displayAddLeadData = false;
                            this.appMainService.isHideSpinner('EditEmployeesNo');
                        })
                        .catch(err => {
                            this.invalidData = false;
                            this.appMainService.isHideSpinner('EditEmployeesNo');
                            const detail = err.status === 422 ? err.error : err.error.Message;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail
                            });
                        });
                }
            } else if (this.leadTypeId == 10) {
                const duplicateRecord = this.leadsStatus.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditLeadStatus(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(statuses => {
                            this.leadsStatus = statuses;
                            this.copiedList = statuses;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.leadTypeId == 0) {
                const duplicateRecord = this.leadsTypes.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditLeadType(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
                            this.leadsTypes = types;
                            this.copiedList = types;
                            this.invalidData = false;
                        });
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.leadTypeId == 7) {
                const duplicateRecord = this.leadsEmail.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.configTemp = {
                        "id": this.emailConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.emailConfigLead.organizationId,
                        "name": this.emailConfigLead.name,
                        "description": this.emailConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.emailConfigLead.objectId,
                        "levelId": this.emailConfigLead.levelId,
                        "levelRecordId": this.emailConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.emailConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.emailConfigLead.typeId
                    }
                    let arr = [];
                    for (let s of this.leadsEmail) {
                        if (s.id == this.leadDataTemp.id) {
                            s = JSON.parse(JSON.stringify(this.leadDataTemp));
                            arr.push(s)
                        } else {
                            arr.push(s);
                        }
                    }
                    this.leadsEmail = JSON.parse(JSON.stringify(arr))
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsEmail);

                    this.service.updateConfiguration(this.configTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.emailConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_EMAIL_TYPES && s.typeId == 93)[0];
                        //     this.leadsEmail = JSON.parse(this.emailConfigLead.configurationDetails[0].configJSONValue);
                        // });
                        this.loadLeadConfigurations();
                        this.invalidData = false;
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.leadTypeId == 8) {
                const duplicateRecord = this.leadsPhone.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.configTemp = {
                        "id": this.phoneConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.phoneConfigLead.organizationId,
                        "name": this.phoneConfigLead.name,
                        "description": this.phoneConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.phoneConfigLead.objectId,
                        "levelId": this.phoneConfigLead.levelId,
                        "levelRecordId": this.phoneConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.phoneConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.phoneConfigLead.typeId
                    }
                    let arr = [];
                    for (let s of this.leadsPhone) {
                        if (s.id == this.leadDataTemp.id) {
                            s = JSON.parse(JSON.stringify(this.leadDataTemp));
                            arr.push(s)
                        } else {
                            arr.push(s);
                        }
                    }
                    this.leadsPhone = JSON.parse(JSON.stringify(arr))
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsPhone);

                    this.service.updateConfiguration(this.configTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.phoneConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_PHONE_TYPES && s.typeId == 94)[0];
                        //     this.leadsPhone = this.phoneConfigLead ? JSON.parse(this.phoneConfigLead.configurationDetails[0].configJSONValue) : [];
                        // });
                        this.loadLeadConfigurations();
                        this.invalidData = false;
                        this.displayAddLeadData = false;
                    });
                }
            } else if (this.leadTypeId == 9) {
                const duplicateRecord = this.leadsSocial.find(depOb => depOb.name.toLowerCase() == this.leadDataTemp.name.toLowerCase() && depOb.id !== this.leadDataTemp.id)
                if (duplicateRecord) {
                    this.invalidData = true;
                } else {
                    this.invalidData = false;
                }

                if (!this.invalidData) {
                    this.configTemp = {
                        "id": this.socialConfigLead.id,
                        "createdSource": this.app.userIP,
                        "updatedSource": this.app.userIP,
                        createdBy: this.app.user.userId,
                        "updatedBy": this.app.user.organizationId,
                        "createdDate": new Date().toISOString(),
                        "updatedDate": new Date().toISOString(),
                        "organizationId": this.socialConfigLead.organizationId,
                        "name": this.socialConfigLead.name,
                        "description": this.socialConfigLead.description,
                        "configJSONSchema": "",
                        "configJSONValue": "",
                        "objectId": this.socialConfigLead.objectId,
                        "levelId": this.socialConfigLead.levelId,
                        "levelRecordId": this.socialConfigLead.configurationDetails[0].levelRecordId,
                        "categoryId": this.socialConfigLead.categoryId,
                        "statusId": 1,
                        "typeId": this.socialConfigLead.typeId
                    }
                    let arr = [];
                    for (let s of this.leadsSocial) {
                        if (s.id == this.leadDataTemp.id) {
                            s = JSON.parse(JSON.stringify(this.leadDataTemp));
                            arr.push(s)
                        } else {
                            arr.push(s);
                        }
                    }
                    this.leadsSocial = JSON.parse(JSON.stringify(arr))
                    this.configTemp.configJSONValue = JSON.stringify(this.leadsSocial);

                    this.service.updateConfiguration(this.configTemp).then(stages => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                        // this.service.getAllConfiguration().subscribe(configs => {
                        //     this.socialConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_SOCIAL_TYPES && s.typeId == 95)[0];
                        //     this.leadsSocial = JSON.parse(this.socialConfigLead.configurationDetails[0].configJSONValue);
                        // });
                        this.loadLeadConfigurations();
                        this.displayAddLeadData = false;
                        this.invalidData = false;
                    });
                }
            } else if (this.leadTypeId == 2) {
                let lowerAccountNames = [];
                this.ratings.forEach(el => {
                    if (el.id != this.leadDataTemp.id) {
                        lowerAccountNames.push(el.name.toLowerCase())
                    }
                });
                if (lowerAccountNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditRating(this.leadDataTemp).then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                        this.loadRatings();
                        this.displayAddLeadData = false;
                        this.formSubmitted = false;
                        this.invalidData = false;
                    });
                }
            } else if (this.leadTypeId == 5) {
                let lowerAccountNames = [];
                this.ownerships.forEach(el => {
                    if (el.id != this.leadDataTemp.id) {
                        lowerAccountNames.push(el.name.toLowerCase())
                    }
                });
                if (lowerAccountNames.indexOf(this.leadDataTemp.name.toLowerCase()) > -1) {
                    this.invalidData = true;
                } else {
                    this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
                    this.service.EditOwnership(this.leadDataTemp)
                        .then(() => {
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
                            this.loadOwnerShipList();
                            this.displayAddLeadData = false;
                            this.invalidData = false;
                        })
                        .catch(err => {
                            this.invalidData = false;
                            const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail
                            });
                        });
                }
            } else if (this.leadTypeId == 11 || this.leadTypeId == 12) {
                this.updateQualifyReason();
            } else if (this.leadTypeId == 13 || this.leadTypeId == 14) {
                this.updateActiveInactiveReason();
            } else if (this.leadTypeId == 15) {
                this.updateCurrency();
            }
        }
    }

    showEditLeadData(c, s) {
        this.leadDataTemp = JSON.parse(JSON.stringify(c));
        this.leadDataTemp['isActive'] = this.leadDataTemp.statusId == 1;

        if ([0, 1, 2, 3, 4, 5, 6, 13, 14, 15].includes(s.id)) {
            this.showActiveBtn = true;
        } else {
            this.showActiveBtn = false;
        }

        this.leadTypeId = s.id;
        this.addEditLeadHeader = "Edit Field Data";
        this.displayAddLeadData = true;
        this.showValidation = false;
    }

    addQualifyReason() {
        let lowerOppNames = [];
        for (let s of (this.selectedLeadDataType.code == 'Qualified' ? this.qualifiedReasons : this.unQualifiedReasons)) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            let addData = {
                ...this.leadDataTemp,
                groupId: (this.selectedLeadDataType.code == 'Qualified' ? this.qualifiedId : this.unQualifiedId)
            };

            this.appMainService.isShowSpinner('addQualifyReason');
            this.leadService.addQualifyReasons(addData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Added Successfully...' });
                this.getQualifyReasons(this.selectedLeadDataType.code, true);
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addQualifyReason');
            }, () => {
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addQualifyReason');
            });
        }
    }

    updateQualifyReason() {
        let lowerOppNames = [];

        const index = this.leadTypeId == 11 ? this.qualifiedReasons.findIndex(s => s.id == this.leadDataTemp.id) :
            this.unQualifiedReasons.findIndex(s => s.id == this.leadDataTemp.id);

        if (this.leadTypeId == 11) {
            this.qualifiedReasons.splice(index, 1);
        } else {
            this.unQualifiedReasons.splice(index, 1);
        }

        for (let s of (this.leadTypeId == 11 ? this.qualifiedReasons : this.unQualifiedReasons)) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }

        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
            let addData = { ...this.leadDataTemp, groupId: this.leadTypeId == 11 ? this.qualifiedId : this.unQualifiedId };
            this.appMainService.isShowSpinner('updateQualifyReasons');
            this.leadService.updateQualifyReasons(addData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Updated Successfully...' });
                this.getQualifyReasons(this.leadTypeId == 11 ? 'Qualified' : 'Un-Qualified');
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('updateQualifyReasons');
            }, () => {
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('updateQualifyReasons');
            });
        }
    }

    delLeadSource(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Lead Source?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteLeadSource');
                this.service.deleteLeadSource(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllSources(this.app.user.organizationId).then(sources => {
                        this.leadsSources = sources;
                    });
                    this.appMainService.isHideSpinner('deleteLeadSource');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteLeadSource');
                    });
            }
        });
    }

    delIndustry(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Industry?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteIndustry');
                this.service.deleteIndustry(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllIndustries().then(industries => {
                        this.industries = industries;
                    });
                    this.appMainService.isHideSpinner('deleteIndustry');
                })
                    .catch(err => {
                        const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteIndustry');
                    });
            }
        });
    }

    delLeadStatus(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Lead Status?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteLeadStatus');
                this.service.deleteLeadStatus(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(statuses => {
                        this.leadsStatus = statuses;
                    });
                    this.appMainService.isHideSpinner('deleteLeadStatus');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteLeadStatus');
                    });
            }
        });
    }

    delRevenue(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Annual Revenue?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteRevenue');
                this.service.deleteRevenue(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllRevenues().then(revenue => {
                        this.revenue = revenue;
                    });
                    this.appMainService.isHideSpinner('deleteRevenue');
                })
                    .catch(err => {
                        const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteRevenue');
                    });
            }
        });
    }

    delEmployeesNo(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this No. of Employees?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteEmployeesNo');
                this.service.deleteEmployeesNo(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllEmployeesCount().then(count => {
                        this.employeesMounts = count;
                    });
                    this.appMainService.isHideSpinner('deleteEmployeesNo');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteEmployeesNo');
                    });
            }
        });
    }

    delLeadsStatus(c) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Lead Status?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteLeadStatus');
                this.service.deleteLeadStatus(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(statuses => {
                        this.leadsStatus = statuses;
                    });
                    this.appMainService.isHideSpinner('deleteLeadStatus');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteLeadStatus');
                    });
            }
        });
    }

    delLeadType(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Lead Type?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteLeadType');
                this.service.deleteLeadType(c.id)
                    .then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
                            this.leadsTypes = types;
                        });
                        this.appMainService.isHideSpinner('deleteLeadType');
                    })
                    .catch(err => {
                        // const detail = err.status === 422 ? err.error : err.error.Message;
                        // this.messageService.add({
                        //     severity: 'error',
                        //     summary: 'Error',
                        //     detail
                        // });
                        this.appMainService.isHideSpinner('deleteLeadType');
                    });
            }
        });
    }

    delLeadEmail(i) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Email Type?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.configTemp = {
                    "id": this.emailConfigLead.id,
                    "createdSource": this.app.userIP,
                    "updatedSource": this.app.userIP,
                    createdBy: this.app.user.userId,
                    "updatedBy": this.app.user.organizationId,
                    "createdDate": new Date().toISOString(),
                    "updatedDate": new Date().toISOString(),
                    "organizationId": this.emailConfigLead.organizationId,
                    "name": this.emailConfigLead.name,
                    "description": this.emailConfigLead.description,
                    "configJSONSchema": "",
                    "configJSONValue": "",
                    "objectId": this.emailConfigLead.objectId,
                    "levelId": this.emailConfigLead.levelId,
                    "levelRecordId": this.emailConfigLead.configurationDetails[0].levelRecordId,
                    "categoryId": this.emailConfigLead.categoryId,
                    "statusId": 1,
                    "typeId": this.emailConfigLead.typeId
                }
                this.leadsEmail.splice(i, 1);
                this.configTemp.configJSONValue = JSON.stringify(this.leadsEmail);

                this.appMainService.isShowSpinner('updateConfiguration');
                this.service.updateConfiguration(this.configTemp).then(stages => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    // this.service.getAllConfiguration().subscribe(configs => {
                    //     this.emailConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_EMAIL_TYPES && s.typeId == 93)[0];
                    //     this.leadsEmail = JSON.parse(this.emailConfigLead.configurationDetails[0].configJSONValue);
                    // });
                    this.loadLeadConfigurations();
                    this.appMainService.isHideSpinner('updateConfiguration');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('updateConfiguration');
                    });
            }
        });
    }

    delLeadPhone(i) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Phone Type?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.configTemp = {
                    "id": this.phoneConfigLead.id,
                    "createdSource": this.app.userIP,
                    "updatedSource": this.app.userIP,
                    createdBy: this.app.user.userId,
                    "updatedBy": this.app.user.organizationId,
                    "createdDate": new Date().toISOString(),
                    "updatedDate": new Date().toISOString(),
                    "organizationId": this.phoneConfigLead.organizationId,
                    "name": this.phoneConfigLead.name,
                    "description": this.phoneConfigLead.description,
                    "configJSONSchema": "",
                    "configJSONValue": "",
                    "objectId": this.phoneConfigLead.objectId,
                    "levelId": this.phoneConfigLead.levelId,
                    "levelRecordId": this.phoneConfigLead.configurationDetails[0].levelRecordId,
                    "categoryId": this.phoneConfigLead.categoryId,
                    "statusId": 1,
                    "typeId": this.phoneConfigLead.typeId
                }
                this.leadsPhone.splice(i, 1);
                this.configTemp.configJSONValue = JSON.stringify(this.leadsPhone);
                this.appMainService.isShowSpinner('updateConfiguration');
                this.service.updateConfiguration(this.configTemp).then(stages => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    // this.service.getAllConfiguration().subscribe(configs => {
                    //     this.phoneConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_PHONE_TYPES && s.typeId == 94)[0];
                    //     this.leadsPhone = this.phoneConfigLead ? JSON.parse(this.phoneConfigLead.configurationDetails[0].configJSONValue) : [];
                    // });
                    this.loadLeadConfigurations();
                    this.appMainService.isHideSpinner('updateConfiguration');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('updateConfiguration');
                    });
            }
        });
    }

    delLeadSocial(i) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Social Type?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.configTemp = {
                    "id": this.socialConfigLead.id,
                    "createdSource": this.app.userIP,
                    "updatedSource": this.app.userIP,
                    createdBy: this.app.user.userId,
                    "updatedBy": this.app.user.organizationId,
                    "createdDate": new Date().toISOString(),
                    "updatedDate": new Date().toISOString(),
                    "organizationId": this.socialConfigLead.organizationId,
                    "name": this.socialConfigLead.name,
                    "description": this.socialConfigLead.description,
                    "configJSONSchema": "",
                    "configJSONValue": "",
                    "objectId": this.socialConfigLead.objectId,
                    "levelId": this.socialConfigLead.levelId,
                    "levelRecordId": this.socialConfigLead.configurationDetails[0].levelRecordId,
                    "categoryId": this.socialConfigLead.categoryId,
                    "statusId": 1,
                    "typeId": this.socialConfigLead.typeId
                }
                this.leadsSocial.splice(i, 1);
                this.configTemp.configJSONValue = JSON.stringify(this.leadsSocial);
                this.appMainService.isShowSpinner('delLeadSocial');
                this.service.updateConfiguration(this.configTemp).then(stages => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    // this.service.getAllConfiguration().subscribe(configs => {
                    //     this.socialConfigLead = configs.filter(s => s.name == ObjectNames.LEAD_SOCIAL_TYPES && s.typeId == 95)[0];
                    //     this.leadsSocial = JSON.parse(this.socialConfigLead.configurationDetails[0].configJSONValue);
                    // });
                    this.loadLeadConfigurations();
                    this.appMainService.isHideSpinner('delLeadSocial');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('delLeadSocial');
                    });
            }
        });
    }

    loadRatings(fromAdd?) {
        this.appMainService.isShowSpinner('loadRatings');
        this.fieldService.getAllRatings().subscribe(ratings => {
            this.ratings = ratings;
            if (fromAdd) {
                this.copiedList = this.ratings;
            }
            this.appMainService.isHideSpinner('loadRatings');
        }, () => {
            this.appMainService.isHideSpinner('loadRatings');
        });
    }

    loadEmployeeCountList() {
        this.appMainService.isShowSpinner('loadEmployeeCountList');
        this.fieldService.getAllEmployeesCount().subscribe(count => {
            this.employeesMounts = count;
            this.appMainService.isHideSpinner('loadEmployeeCountList');
        }, () => {
            this.appMainService.isHideSpinner('loadEmployeeCountList');
        });
    }

    loadRevenuList() {
        this.appMainService.isShowSpinner('loadRevenuList');
        this.fieldService.getAllRevenues().subscribe(revenue => {
            this.revenue = revenue;
            this.appMainService.isHideSpinner('loadRevenuList');
        }, () => {
            this.appMainService.isHideSpinner('loadRevenuList');
        });
    }

    loadOwnerShipList(fromAdd?) {
        this.appMainService.isShowSpinner('loadOwnerShipList');
        this.fieldService.getAllOwnerships().subscribe(owners => {
            this.ownerships = owners;
            if (fromAdd) {
                this.copiedList = this.ownerships;
            }
            this.appMainService.isHideSpinner('loadOwnerShipList');
        }, () => {
            this.appMainService.isHideSpinner('loadOwnerShipList');
        });
    }

    loadIndustries() {
        this.appMainService.isShowSpinner('loadIndustries');
        this.fieldService.getAllIndustries().subscribe(industries => {
            this.industries = industries;
            this.appMainService.isHideSpinner('loadIndustries');
        }, () => {
            this.appMainService.isHideSpinner('loadIndustries');
        });
    }

    delRating(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Rating?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('delRating');
                this.service.deleteRating(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rating Deleted Successfully...' });
                    this.loadRatings();
                    this.appMainService.isHideSpinner('delRating');
                })
                    .catch(err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('delRating');
                    });
            }
        });
    }

    delOwnership(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Ownership Type?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('delOwnership');
                this.service.deleteOwnership(c.id).then(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                    this.loadOwnerShipList();
                    this.appMainService.isHideSpinner('delOwnership');
                })
                    .catch(err => {
                        const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('delOwnership');
                    });
            }
        });
    }

    deleteQualifyReason(c, s) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Reason?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteQualifyReason');
                this.leadService.deleteQualifyReasons(c.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
                    if (s.id == 11) {
                        this.getQualifyReasons('Qualified');
                    } else {
                        this.getQualifyReasons('Un-Qualified');
                    }
                    this.appMainService.isHideSpinner('deleteQualifyReason');
                },
                    err => {
                        const detail = err.status === 422 ? err.error : err.error.Message;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail
                        });
                        this.appMainService.isHideSpinner('deleteQualifyReason');
                    });
            }
        });
    }

    addCurrency() {
        let lowerOppNames = [];

        for (let s of this.currencies) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            let addData = {
                ...this.leadDataTemp,
            };
            this.appMainService.isShowSpinner('addCurrency');
            this.service.addCurrency(addData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency Added Successfully...' });
                this.loadCurrencies(true);
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addCurrency');
            }, () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'An error occurred while saving currency...'
                });
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addCurrency');
            });
        }
    }

    updateCurrency() {
        let lowerOppNames = [];

        const index = this.currencies.findIndex(s => s.id == this.leadDataTemp.id);

        this.currencies.splice(index, 1);

        for (let s of this.currencies) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }

        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            let updateData = { ...this.leadDataTemp };
            updateData.statusId = updateData.isActive ? 1 : 2;
            this.appMainService.isShowSpinner('updateCurrency');
            this.service.updateCurrency(updateData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency Updated Successfully...' });
                this.loadCurrencies();
                this.displayAddLeadData = false;
                this.appMainService.isHideSpinner('updateCurrency');
            }, (err) => {
                this.displayAddLeadData = false;
                const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail
                });
                this.appMainService.isHideSpinner('updateCurrency');
            });
        }
    }

    deleteCurrency(c) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this currency?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteCurrency');
                this.service.deleteCurrency(c.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Currency deleted successfully...' });
                    this.loadCurrencies();
                    this.appMainService.isHideSpinner('deleteCurrency');
                }, (err) => {
                    const detail = (err.status === 422 || err.status === 500) ? err.error : err.error.Message;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail
                    });
                    this.appMainService.isHideSpinner('deleteCurrency');
                });
            }
        });
    }

    openAccordion(event) {
        switch (event.index) {
            case 0: {
                this.copiedTypes = JSON.parse(JSON.stringify(this.leadsTypes));
                break;
            }
            case 1: {
                this.copiedSources = JSON.parse(JSON.stringify(this.leadsSources));
                break;
            }
            case 2: {
                this.copiedList = JSON.parse(JSON.stringify(this.ratings));
                break;
            }
            case 3: {
                this.copiedList = JSON.parse(JSON.stringify(this.employeesMounts));
                break;
            }
            case 4: {
                this.copiedList = JSON.parse(JSON.stringify(this.revenue));
                break;
            }
            case 5: {
                this.copiedList = JSON.parse(JSON.stringify(this.ownerships));
                break;
            }
            case 6: {
                this.copiedList = JSON.parse(JSON.stringify(this.industries));
                break;
            }
            case 15: {
                this.copiedList = JSON.parse(JSON.stringify(this.currencies));
                break;
            }
        }
    }

    makeLeadTypeDefault(data) {
        this.leadsTypes.forEach(element => {
            if (element.id != data.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultLeadType(element);
            }
        });

        this.appMainService.isShowSpinner('makeLeadTypeDefault');

        this.service.EditLeadType(data).then(() => {
            this.appMainService.isHideSpinner('makeLeadTypeDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.fetchLeadsTypes();
        }, () => {
            this.appMainService.isHideSpinner('makeLeadTypeDefault');
        });
    }

    updateDefaultLeadType(updateData) {
        this.appMainService.isShowSpinner('updateDefaultLeadType');
        this.service.EditLeadType(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultLeadType');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultLeadType');
        });
    }

    makeLeadSourceDefault(data) {
        const currentData = this.copiedSources.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.leadsSources.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultLeadSource(element);
            }
        });

        this.appMainService.isShowSpinner('makeLeadSourceDefault');

        this.service.EditLeadSource(currentData).then(() => {
            this.appMainService.isHideSpinner('makeLeadSourceDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.fetchLeadsSources();
        }, () => {
            this.appMainService.isHideSpinner('makeLeadSourceDefault');
        });
    }

    updateDefaultLeadSource(updateData) {
        this.appMainService.isShowSpinner('updateDefaultLeadSource');
        this.service.EditLeadSource(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultLeadSource');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultLeadSource');
        });
    }

    makeRatingDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.ratings.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultRating(element);
            }
        });

        this.appMainService.isShowSpinner('makeRatingDefault');

        this.service.EditRating(currentData).then(() => {
            this.appMainService.isHideSpinner('makeRatingDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadRatings();
        }, () => {
            this.appMainService.isHideSpinner('makeRatingDefault');
        });
    }

    updateDefaultRating(updateData) {
        this.appMainService.isShowSpinner('updateDefaultRating');
        this.service.EditRating(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultRating');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultRating');
        });
    }

    makeEmployeesCountDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.employeesMounts.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultEmployeesCount(element);
            }
        });

        this.appMainService.isShowSpinner('makeEmployeesCountDefault');

        this.service.EditEmployeesNo(currentData).then(() => {
            this.appMainService.isHideSpinner('makeEmployeesCountDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadEmployeeCountList();
        }, () => {
            this.appMainService.isHideSpinner('makeEmployeesCountDefault');
        });
    }

    updateDefaultEmployeesCount(updateData) {
        this.appMainService.isShowSpinner('updateDefaultEmployeesCount');
        this.service.EditEmployeesNo(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultEmployeesCount');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultEmployeesCount');
        });
    }

    makeRevenueDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.revenue.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultRevenue(element);
            }
        });

        this.appMainService.isShowSpinner('makeRevenueDefault');

        this.service.EditRevenue(currentData).then(() => {
            this.appMainService.isHideSpinner('makeRevenueDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadRevenuList();
        }, () => {
            this.appMainService.isHideSpinner('makeRevenueDefault');
        });
    }

    updateDefaultRevenue(updateData) {
        this.appMainService.isShowSpinner('updateDefaultRevenue');
        this.service.EditRevenue(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultRevenue');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultRevenue');
        });
    }

    makeOwnershipDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.ownerships.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultOwnership(element);
            }
        });

        this.appMainService.isShowSpinner('makeOwnershipDefault');

        this.service.EditOwnership(currentData).then(() => {
            this.appMainService.isHideSpinner('makeOwnershipDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadOwnerShipList();
        }, () => {
            this.appMainService.isHideSpinner('makeOwnershipDefault');
        });
    }

    updateDefaultOwnership(updateData) {
        this.appMainService.isShowSpinner('updateDefaultOwnership');
        this.service.EditOwnership(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultOwnership');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultOwnership');
        });
    }

    makeIndustryDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.industries.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultIndustry(element);
            }
        });

        this.appMainService.isShowSpinner('makeIndustryDefault');

        this.service.EditIndustry(currentData).then(() => {
            this.appMainService.isHideSpinner('makeIndustryDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadIndustries();
        }, () => {
            this.appMainService.isHideSpinner('makeIndustryDefault');
        });
    }

    updateDefaultIndustry(updateData) {
        this.appMainService.isShowSpinner('updateDefaultIndustry');
        this.service.EditIndustry(updateData).then(() => {
            this.appMainService.isHideSpinner('updateDefaultIndustry');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultIndustry');
        });
    }

    makeCurrencyDefault(data) {
        const currentData = this.copiedList.filter(el => el.id === data.id)[0];
        currentData.isDefault = !currentData.isDefault;

        this.currencies.forEach(element => {
            if (element.id != currentData.id && element.isDefault === true) {
                element.isDefault = false;
                this.updateDefaultCurrency(element);
            }
        });

        this.appMainService.isShowSpinner('makeCurrencyDefault');

        this.service.updateCurrency(currentData).toPromise().then(() => {
            this.appMainService.isHideSpinner('makeCurrencyDefault');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.loadCurrencies();
        }, () => {
            this.appMainService.isHideSpinner('makeCurrencyDefault');
        });
    }

    updateDefaultCurrency(updateData) {
        this.appMainService.isShowSpinner('updateDefaultCurrency');
        this.service.updateCurrency(updateData).toPromise().then(() => {
            this.appMainService.isHideSpinner('updateDefaultCurrency');
        }, () => {
            this.appMainService.isHideSpinner('updateDefaultCurrency');
        });
    }

    // if (channel.isDefault) {
    //     this.channelList.forEach(element => {
    //       if (element.id != channel.id) {
    //         element.isDefault = false;
    //       }
    //     });
    //     this.updateChannel(channel);
    //   }

    makeDefault(data) {
        let updateData = data;
        if (updateData.groupId == this.qualifiedId) {
            this.qualifiedReasons.forEach(element => {
                if (element.id != updateData.id && element.isDefault === true) {
                    element.isDefault = false;
                    this._updateDefaultData(element);
                }
            });
        } else {
            this.unQualifiedReasons.forEach(element => {
                if (element.id != updateData.id && element.isDefault === true) {
                    element.isDefault = false;
                    this._updateDefaultData(element);
                }
            });
        }

        this.appMainService.isShowSpinner('updateChannel')
        this.leadService.updateQualifyReasons(updateData).subscribe(() => {
            this.appMainService.isHideSpinner('updateChannel')
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.getQualifyReasons(updateData.groupId == this.qualifiedId ? 'Qualified' : 'Un-Qualified');
        }, err => {
            this.appMainService.isHideSpinner('updateChannel');
        });
    }

    _updateDefaultData(updateData) {
        this.appMainService.isShowSpinner('updateChannel')
        this.leadService.updateQualifyReasons(updateData).subscribe(stages => {
            this.appMainService.isHideSpinner('updateChannel')
        }, () => {
            this.appMainService.isHideSpinner('updateChannel')
        });
    }

    getActiveInactiveReason(groupName: string, fromAdd?): void {
        this.appMainService.isShowSpinner('getActiveInActiveReasons');

        this.leadService.getActiveInactiveDataByName(groupName).subscribe(
            dataName => {
                this.appMainService.isHideSpinner('getActiveInActiveReasons');
                dataName &&
                    this.leadService.getActiveInactiveReasons(dataName.id).subscribe(
                        res => {
                            if (groupName == 'LeadActivatedReason') {
                                this.activeId = dataName.id;
                                this.activeReason = res ? res : [];
                                this.activeReason.sort((a, b) => a.name.localeCompare(b.name));

                                if (fromAdd) {
                                    this.copiedList = this.activeReason;
                                }
                            } else {
                                this.inactiveId = dataName.id;
                                this.inactiveReason = res ? res : [];
                                this.inactiveReason.sort((a, b) => a.name.localeCompare(b.name));

                                if (fromAdd) {
                                    this.copiedList = this.inactiveReason;
                                }
                            }
                        },
                        () => {
                            this.appMainService.isHideSpinner('getActiveInActiveReasons');
                        });
            },
            () => {
                this.appMainService.isHideSpinner('getActiveInActiveReasons');
            })
    }

    addActiveInactiveReason() {
        let lowerOppNames = [];

        for (let s of (this.selectedLeadDataType.code == 'LeadActivatedReason' ? this.activeReason : this.inactiveReason)) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }

        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            let addData = {
                ...this.leadDataTemp,
                groupId: (this.selectedLeadDataType.code == 'LeadActivatedReason' ? this.activeId : this.inactiveId)
            };
            this.appMainService.isShowSpinner('addActiveInActiveReason');
            this.leadService.addActiveInactiveReasons(addData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Added Successfully...' });
                this.getActiveInactiveReason(this.selectedLeadDataType.code, true);
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addActiveInActiveReason');
            }, () => {
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('addActiveInActiveReason');
            });
        }
    }

    updateActiveInactiveReason() {
        let lowerOppNames = [];

        const index = this.leadTypeId == 13 ? this.activeReason.findIndex(s => s.id == this.leadDataTemp.id) :
            this.inactiveReason.findIndex(s => s.id == this.leadDataTemp.id);

        if (this.leadTypeId == 13) {
            this.activeReason.splice(index, 1);
        } else {
            this.inactiveReason.splice(index, 1);
        }

        for (let s of (this.leadTypeId == 13 ? this.activeReason : this.inactiveReason)) {
            lowerOppNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }

        if (lowerOppNames.indexOf(this.leadDataTemp.name.toLowerCase().replace(/ /g, '')) > -1) {
            this.invalidData = true;
        } else {
            this.leadDataTemp.statusId = this.leadDataTemp.isActive ? 1 : 2;
            let addData = { ...this.leadDataTemp, groupId: this.leadTypeId == 13 ? this.activeId : this.inactiveId };
            this.appMainService.isShowSpinner('updateActiveInActiveReason');
            this.leadService.updateActiveInactiveReasons(addData).subscribe(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Data Updated Successfully...' });
                this.getActiveInactiveReason(this.leadTypeId == 13 ? 'LeadActivatedReason' : 'LeadInactivatedReason');
                this.displayAddLeadData = false;
                this.invalidData = false;
                this.appMainService.isHideSpinner('updateActiveInActiveReason');
            }, () => {
                this.displayAddLeadData = false;
                this.appMainService.isHideSpinner('updateActiveInActiveReason');
            });
        }
    }

    makeActiveInactiveDefault(data) {
        let updateData = data;
        if (updateData.groupId == this.activeId) {
            this.activeReason.forEach(element => {
                if (element.id != updateData.id && element.isDefault === true) {
                    element.isDefault = false;
                    this._updateDefaultData(element);
                }
            });
        } else {
            this.inactiveReason.forEach(element => {
                if (element.id != updateData.id && element.isDefault === true) {
                    element.isDefault = false;
                    this._updateDefaultData(element);
                }
            });
        }

        this.appMainService.isShowSpinner('updateChannel');
        this.leadService.updateActiveInactiveReasons(updateData).subscribe(() => {
            this.appMainService.isHideSpinner('updateChannel');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Default Data Updated Successfully...' });
            this.getActiveInactiveReason(updateData.groupId == this.activeId ? 'LeadActivatedReason' : 'LeadInactivatedReason');
        }, () => {
            this.appMainService.isHideSpinner('updateChannel');
        });
    }

    deleteActiveInactiveReason(c, s) {
        if (c.isDefault) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Can not delete isDefault data' });
            return;
        }

        this.confirmationService.confirm({
            message: 'Do you want to delete this Reason?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteActiveInactiveReason');
                this.leadService.deleteActiveInactiveReasons(c.id).subscribe(() => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reason Deleted Successfully...' });
                    if (s.id == 13) {
                        this.getActiveInactiveReason('LeadActivatedReason');
                    } else {
                        this.getActiveInactiveReason('LeadInactivatedReason');
                    }
                    this.appMainService.isHideSpinner('deleteActiveInactiveReason');
                }, (err) => {
                    const detail = err.status === 422 ? err.error : err.error.Message;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail
                    });
                    this.appMainService.isHideSpinner('deleteActiveInactiveReason');
                });
            }
        });
    }

    cancleAddEditFieldData() {
        this.displayAddLeadData = false;
        this.invalidData = false;
    }

    confirm(data) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            rejectLabel: "Cancel",
            accept: () => {
                data.isDefault = !data.isDefault;
            },
        });
    }

    loadTages(){
        this.fieldService.getAllTags().subscribe({
          next:(tags)=>{
            this.tagList = tags;
          }
        })
    }

    addTags(){
        let newTag:{id:number,name:string,color:string} = {
            id:0,
            name:this.leadDataTemp?.name.trim(),
            color:this.leadDataTemp?.color
        }
        this.fieldService.addTags(newTag).subscribe({
            next:(data)=>{
            if(data == null){
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
            }else{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Added Successfully...' });
                this.displayAddLeadData = false;
                this.invalidData = false;
            }
            }
        });
    }

    showEditTag(tag){
        this.displayEditTag = true;
        this.tempTag = {
            id: tag?.id,
            name: tag?.name,
            color: tag?.color,
            statusId: tag?.statusId,
            isActive: tag?.statusId == 1 ? true : false,
        }
    }

    saveTag(){
        let requestBody = {
            id: this.tempTag?.id,
            name: this.tempTag?.name.trim(),
            color: this.tempTag?.color,
            statusId: this.tempTag?.isActive ? 1 : 2,
        }
        this.fieldService.editTags(requestBody).subscribe({
            next:(data)=>{
            if(data == null){
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Duplicate tag names are not allowed.' });
            }else{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully updated...' });
                this.displayEditTag = false;
                this.loadTages();
            }
            }
        });
    }

    deleteTag(tag){
        this.confirmationService.confirm({
            message: 'Do you want to delete this Tag?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
            this.fieldService.deleteTags(tag?.id).subscribe({
                next:(data)=>{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tag is Successfully updated...' });
                this.loadTages();
                }
            });
            }
        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
